module.exports = __webpack_public_path__ + "img/f56754f.png";